/* eslint-disable react/prop-types */
import React from "react";
import { Typography } from "@material-ui/core";

/* This is used for the tenant tab
This returns the same company value to not break the table showcase when deleting tenants */
export default function TenantCompanyLabel({ rowData }) {
  return rowData.company ? (
    <Typography display="inline" variant="body1">
      {rowData.company.name}
    </Typography>
  ) : null;
}
